/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import Person from "./Person";


export default class Contact extends BaseCom {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(v) {
        if(this.props.onChange)
            this.props.onChange();
    }

    render() {
        return <>
            <Person item={this.props.item} title="Contact" requestAddress requireOnlyBasic />
            <Card title="Notifications">
                <div className="row">
                    <div className="col">
                        <FormInput model={this.props.item} name="email" label="Email" type="email" required />
                    </div>
                    <div className="col">
                        <FormInput model={this.props.item} name="phone" label="Phone" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.props.item} name="fax" label="Fax" type="text" />
                    </div>
                </div>
            </Card>
        </>;
    }
}